import {useEffect, useState} from 'react'

import AdminNavBar from './AdminNavBar'
import ReportNavBar from './ReportNavBar'

interface LoggedInUser {
	id: number;
	first_name: string;
	last_name: string;
	location: string;
	unit: string;
	event_date: Date;
	event_time: Date;
}

const FlaggedEntries = () => {
	const [loggedInUsers, setLoggedInUsers] = useState<LoggedInUser[]>([])
	
	useEffect(() => {
		const fetchLoggedInUsers = async () => {
			try {
				const response = await fetch(process.env.REACT_APP_API+"/api/reportFlaggedEntries")
				const results = await response.json()
				for (var i = 0; i < results.length; i++) {
					// add 1 day to results[i].logged_in_date
					results[i].event_date = new Date(results[i].event_date)
					results[i].event_date.setDate(results[i].event_date.getDate() + 1) // adjust for timezone
					// add 1 hour to results[i].logged_in_time
					results[i].event_time = new Date(results[i].event_time)
					results[i].event_time.setHours(results[i].event_time.getHours() + 1) // adjust for timezone
				}
				setLoggedInUsers(results)
			} catch (error) {
				console.log(error)
			}
		}
		fetchLoggedInUsers()
	}, [])

	const getPDF = async () => {
		try {
			const response = await fetch(process.env.REACT_APP_API+"/api/pdfFlaggedEntries")
			const blob = await response.blob()
			const url = window.URL.createObjectURL(blob)
			const a = document.createElement('a')
			a.href =
				url
			a.download = 'flagged_entries.pdf'
			document.body.appendChild(a)
			a.click()
			a.remove()
		}
		catch (error) {
			console.log(error)
		}
	}
	
	return (
		<div className="resilire">
			<AdminNavBar />
			<ReportNavBar />
			<br />
			<table id="logged_in_users">
				<thead><tr><th colSpan={5}>Flagged Entries</th></tr></thead>
				<tbody>
					<tr><th>Name</th><th>Location</th><th>Unit</th><th>Clock in/out Date</th><th>Clock in/out time</th></tr>
					{loggedInUsers.map((user) => (
						<tr key={user.id}>
							<td>{user.first_name} {user.last_name}</td>
							<td>{user.location}</td>
							<td>{user.unit}</td>
							<td>{new Date(user.event_date).toLocaleDateString()}</td>
							<td>{new Date(user.event_time).toLocaleTimeString()}</td>
						</tr>
					))}
				</tbody>
			</table>
			<button onClick={getPDF}>Download</button>
		</div>
	)
};

export default FlaggedEntries;
